import React from 'react'
import styled from 'styled-components'
import Line from 'features/list/components/line'

export default ({ events }) => (
  <AllDayEvents className="all-day-events">
    {events.map((event, index) => (
      <Line item={event} key={`${event.title}-${index}`} onClick={e => openEventTab(e, event.webLink)} />
    ))}
  </AllDayEvents>
)

const openEventTab = (e, link) => {
  if (!link) {
    return
  }
  window.open(link)
}

const AllDayEvents = styled.div`
  border-radius: 16px;
  margin-bottom: 20px;
  .line {
    background-color: #ebeaee;
  }
`



// WEBPACK FOOTER //
// ./src/features/todolist/components/allDayEvents/index.js